// extracted by mini-css-extract-plugin
module.exports = {"img404":"Register_img404__1S0xk"};